import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';

import Text from '../../../components/Text/Text';
import Input from '../../../components/Input/Input';
import Button from '../../../components/Button/Button';
import { IconArrowRight, IconLoading } from '../../../assets/icon';
import TagsInput from '../../../components/TagsInput/TagsInput';
import ButtonTypes from '../../../constants/buttonTypes';
import Card from '../../../components/Card/Card';
import getListingCompatibilityList from '../../../thunks/Compatibility/getListingCompatibilityList';
import updateListingCompatibilityList, {
  clearUpdateListingCompatibilityList
} from '../../../thunks/Compatibility/updateListingCompatibilityList';

const cardContainerClassName = 'w-full lg:max-w-[420px] lg:mr-[40px]';
const cardBodyClassName = 'pt-0';
const inputClassName = 'py-[8px] px-[13px]';
const inputGroupClassName = 'flex flex-col sm:flex-row gap-[8px] sm:items-center';
const inputButtonClassName = 'w-full sm:w-auto';

const ListingInfo = ({ sourceId, setSourceId }) => {
  const dispatch = useDispatch();
  const [applyTo, setApplyTo] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const { loading, error, carList } = useSelector((state) => ({
    loading: state?.getListingCompatibilityList.loading,
    error: state?.getListingCompatibilityList.error,
    carList: state?.getListingCompatibilityList.data,
  }), shallowEqual);

  const { loadingUpdate, errorUpdate, dataUpdate } = useSelector((state) => ({
    loadingUpdate: state?.updateListingCompatibilityList.loading,
    errorUpdate: state?.updateListingCompatibilityList.error,
    dataUpdate: state?.updateListingCompatibilityList.data,
  }), shallowEqual);
  useEffect(() => {
    if (error || errorUpdate) {
      enqueueSnackbar(error || errorUpdate, { variant: 'error' });
      dispatch(clearUpdateListingCompatibilityList());
    }
  }, [error, errorUpdate]);

  useEffect(() => {
    if (dataUpdate) {
      enqueueSnackbar('Car list updated successfully', { variant: 'success' });
      dispatch(clearUpdateListingCompatibilityList());
    }
  }, [dataUpdate]);

  const onGetSource = () => dispatch(getListingCompatibilityList(sourceId));

  const onApply = () => {
    dispatch(updateListingCompatibilityList({
      car_list: carList,
      listings_id: applyTo,
    }));
  };

  return (
    <Card
      headerTitle="Listing info"
      showHeader
      headerBordered={false}
      styleContainer={cardContainerClassName}
      styleBodyContainer={cardBodyClassName}
    >
      <div>
        <Text text="Source listing id:" muted />
        <div className={`d-flex d-row inputGroup ${inputGroupClassName}`}>
          <Input
            type="text"
            name="source_listing_id"
            value={sourceId}
            placeholder="Source listing id"
            onChange={({ target: { value } }) => setSourceId(value)}
            inputStyle={inputClassName}
          />
          <Button
            tooltipId="sync_btn"
            tooltip="Get car list from source item"
            icon={loading ? <IconLoading className="spin" /> : <IconArrowRight />}
            disabled={!sourceId.length}
            onClick={onGetSource}
            containerStyle={inputButtonClassName}
          />
        </div>
      </div>
      <div>
        <Text text="Apply to listings:" muted />
        <TagsInput
          tagType={ButtonTypes.LIGHT}
          maxTagsCount={10}
          onTagsChange={setApplyTo}
        />
      </div>
      <br />
      <Button
        text="Apply"
        disabled={(!!carList && !applyTo.length) || loadingUpdate}
        onClick={onApply}
      />
      <br />
    </Card>
  );
};

ListingInfo.propTypes = {
  setSourceId: PropTypes.func.isRequired,
  sourceId: PropTypes.string.isRequired,
};

export default ListingInfo;
